<script setup lang="ts">

import { usePresentation } from '@presentation/Types';
import IntroductionPageOptions from '@presentation/Components/IntroductionPageOptions.vue';
import { useLead } from '../../Types/Lead';
import { Map } from '../../Types/Map';

const presentation = usePresentation();
const lead = useLead();

function start()
{
    lead.startNew( 'xxxx-xxxx-xxxxxx-xxxxxxxx', '17' );
    presentation.goto( Map.Greeting );
}

</script>

<template>

    <div class="flex flex-col min-h-full grow items-center justify-center gap-8">
        
        <Image src="/logo-small.png" class="w-4/5 md:w-3/5 lg:w-2/5" />

        <h1 class="text-2xl md:text-3xl lg:text-4xl font-semibold uppercase opacity-30 text-center">
            Karate for everyone!
        </h1>

        <IntroductionPageOptions />

        <button 
            @click.stop="() => start()"
            class="bg-gray-100 text-black hover:brightness-110 rounded-md p-4 shadow tracking-wider font-semibold uppercase mt-4">
            Start Presentation
        </button>

        <button @click="presentation.toggleFullscreen" class="hidden lg:block tracking-wider -mt-4 opacity-60">
            Toggle Fullscreen
        </button>

        <a href="https://www.gkrkarate.com/" class="absolute bottom-4 opacity-50">https://www.gkrkarate.com/</a>

    </div>

</template>